{
    "(None)": "",
    "(save {highestYearlyDiscount}%)": "",
    "{amount} days free": "{amount} dite falas",
    "{amount} off": "{amount} zbritje",
    "{amount} off for first {number} months.": "{amount} zbritje në {number} muajt e parë",
    "{amount} off for first {period}.": "{amount} zbritje per {period} e parë",
    "{amount} off forever.": "{amount} zbritje pergjithmone.",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "{buyerName} has gifted you a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "{discount}% discount": "{discount}% zbritje",
    "{duration} membership": "",
    "{field}: {message}": "",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "{memberEmail} nuk do te marre me buletinin e {newsletterName}",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "{memberEmail} nuk do të marrë më email kur dikush u përgjigjet komenteve tuaja.",
    "{memberEmail} will no longer receive this newsletter.": "{memberEmail} nuk do te marre me kete buletin.",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} month": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "Anëtarësimi {tierName}",
    "{trialDays} days free": "{trialDays} dite falas",
    "{years} years": "",
    "+1 (123) 456-7890": "",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "Llogaria",
    "Account details updated successfully": "",
    "Account settings": "Cilësimet e llogarisë",
    "Add a personal note": "",
    "Add a short note to go with your gift": "",
    "Address line 1": "",
    "Address line 2": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "Pasi të përfundojë një provë falas, ju do të tarifoheni me çmimin e rregullt për nivelin që keni zgjedhur. Mund të anuloni gjithmonë përpara kësaj.",
    "Already a member?": "Tashme nje antar?",
    "An error occurred": "",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "Ndodhi një gabim i papritur. Provo sërish ose <a>kontakto mbështetjen</a> nëse gabimi vazhdon.",
    "Back": "Kthehu",
    "Back to Log in": "Kthehu tek identifikimi",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "E premtja e zeze",
    "Bluesky": "",
    "Buy": "",
    "Buying for someone else?": "",
    "Cancel anytime.": "Anullo ne cdo kohe.",
    "Cancel subscription": "Anullo abonimin",
    "Canceled": "",
    "Cancellation reason": "Arsyeja e anullimit",
    "Change": "Ndrysho",
    "Change plan": "",
    "Check spam & promotions folders": "Kontrolloni dosjet e postës së padëshiruar dhe promovimeve ",
    "Check with your mail provider": "Kontrolloni me ofruesin tuaj të postës",
    "Check your inbox to verify email update": "",
    "Choose": "Zgjidh",
    "Choose a date from today onwards": "",
    "Choose a date within the next year": "",
    "Choose a delivery date": "",
    "Choose a different plan": "Zgjidh nje plan ndryshe",
    "Choose a plan": "",
    "Choose a tier": "",
    "Choose your newsletters": "Zgjidh buletinin tend",
    "City": "",
    "Click here to retry": "Kliko ketu per te provuar perseri",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "Mbyll",
    "Code": "",
    "Comment preferences updated.": "",
    "Comments": "Komentet",
    "Complimentary": "Pa pagesë",
    "Confirm": "Konfirmo",
    "Confirm cancellation": "Konfirmo anullimin",
    "Confirm subscription": "Konfirmo abonimin",
    "Contact support": "Kontakto suportin",
    "Continue": "Vazhdoni",
    "Continue subscription": "Vazhdoni abonimin",
    "Continue to delivery details": "",
    "Continue to payment": "",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "",
    "Could not sign in. Login link expired.": "",
    "Could not update email! Invalid link.": "",
    "Country": "",
    "Create a new contact": "Shto nje kontakt te ri",
    "Current plan": "Plani aktual",
    "Delete account": "Fshini llogarine",
    "Delivery date": "",
    "Delivery method": "",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "Nuk doje ta bëje këtë? Menaxho preferencat e tua <button>këtu</button>.",
    "Don't have an account?": "Nuk keni nje llogari?",
    "Edit": "Modifiko",
    "Email": "Email",
    "Email confirmation link expired.": "",
    "Email it to them": "",
    "Email newsletter": "Buletini i emailit",
    "Email newsletter settings updated": "",
    "Email preferences": "Preferenat e emailit",
    "Email preferences updated.": "",
    "Emails": "Emailet",
    "Emails disabled": "Emailet e çaktivizuara",
    "Ends {offerEndDate}": "Perfundon {offerEndDate}",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "",
    "Enter the recipient's email address": "",
    "Enter your email address": "",
    "Enter your name": "",
    "Error": "Gabim",
    "Expires {expiryDate}": "Mbaron {expiryDate}",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "",
    "Failed to log in, please try again": "",
    "Failed to log out, please try again": "",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "",
    "Failed to send magic link email": "",
    "Failed to send verification email": "",
    "Failed to sign up, please try again": "",
    "Failed to update account data": "",
    "Failed to update account details": "",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "",
    "Failed to update subscription, please try again": "",
    "Failed to verify code, please try again": "",
    "For a friend or colleague": "",
    "Forever": "Pergjithmone",
    "Free Trial – Ends {trialEnd}": "Prova falas – mbaron {trialEnd}",
    "From": "",
    "Get help": "Merr ndihme",
    "Get in touch for help": "Kontaktoni për ndihmë",
    "Get notified when someone replies to your comment": "",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift duration": "",
    "Gift link copied to clipboard": "",
    "Gift membership": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "Ler nje koment ne kete post",
    "Help! I'm not receiving emails": "Ndihme! Nuk po marr emaile",
    "Here are a few other sites you may enjoy.": "",
    "Hi {recipientName},": "",
    "Hide details": "",
    "How would you like to share this gift?": "",
    "I'll share it myself": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "Nëse një buletin shënohet si i padëshiruar, emailet çaktivizohen automatikisht për atë adresë për t'u siguruar që nuk do të merrni më mesazhe të padëshiruara.",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "Nëse ankesa për postën e padëshiruar ishte aksidentale, ose dëshironi të filloni të merrni përsëri email, mund të regjistroheni përsëri në email duke klikuar butonin në ekranin e mëparshëm.",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "Nëse e anuloni abonimin tuaj tani, do të vazhdoni të keni akses deri në {periodEnd}.",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "Nëse keni një llogari të postës elektronike të korporatës ose të qeverisë, kontaktoni departamentin tuaj të IT dhe kërkojuni që të lejojnë marrjen e emaileve nga {senderEmail}",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "Një lidhje identifikimi është dërguar në kutinë tuaj hyrëse. Nëse nuk arrin për 3 minuta, sigurohuni që të kontrolloni dosjen tuaj të postës së padëshiruar.",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "Nëse dëshironi të filloni të merrni përsëri emaile, hapat më të mirë të metejshem janë të kontrolloni adresën tuaj të emailit në dosje për ndonjë problem dhe më pas klikoni Ri-abonohu në ekranin e mëparshëm.",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "Nëse nuk po merrni buletinin me email në të cilin jeni abonuar, këtu janë disa gjëra për të kontrolluar.",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "Nëse i keni përfunduar të gjitha këto kontrolle dhe ende nuk po merrni email, mund të kontaktoni për të marrë mbështetje duke kontaktuar {supportAddress}.",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "Në rast se merret një dështim i përhershëm gjatë përpjekjes për të dërguar një buletin, emailet do të çaktivizohen në llogari.",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "Në klientin tuaj të postës elektronike shtoni {senderEmail} në listën tuaj të kontakteve. Kjo i sinjalizon ofruesit tuaj të postës elektronike që emailet e dërguara nga kjo adresë duhet të jenë të besueshme.",
    "Invalid email address": "",
    "Invalid verification code": "",
    "Jamie Larson": "",
    "jamie@example.com": "",
    "Less like this": "Më pak të tilla",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "Sigurohuni që emailet të mos përfundojnë aksidentalisht në dosjet e postës së padëshiruar ose të promovimeve të kutisë suaj hyrëse. Nëse janë, klikoni në \"Shëno si jo të padëshiruar\" dhe/ose \"Lëviz te kutia hyrëse\".",
    "Manage": "Menaxho",
    "Maybe later": "",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "",
    "Memberships unavailable, contact the owner for access.": "",
    "month": "muaj",
    "Monthly": "Mujore",
    "More like this": "Më shumë të tilla",
    "More options": "",
    "Name": "Emri",
    "Need more help? Contact support": "Te duhet me shume ndihme? Kontakto suportin",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "Buletinet mund të çaktivizohen në llogarinë tuaj për dy arsye: Një email i mëparshëm u shënua si i padëshiruar, ose përpjekja për të dërguar një email rezultoi në një dështim të përhershëm (kercim).",
    "No member exists with this e-mail address.": "",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "Nuk po merr emaile?",
    "Now": "",
    "Now check your email!": "Kontrollo emailin tend tani!",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "Pasi të regjistroheni përsëri, nëse ende nuk i shihni emailet në kutinë tuaj hyrëse, kontrolloni dosjen tuaj të postës së padëshiruar. Disa ofrues të kutisë hyrëse mbajnë një regjistër të ankesave të mëparshme të postës së padëshiruar dhe do të vazhdojnë të raportojnë emailet. Nëse kjo ndodh, shëno buletinin më të fundit si 'Jo e padëshiruar' për ta zhvendosur atë në kutinë hyrëse kryesore.",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Optional message": "",
    "Permanent failure (bounce)": "Deshtim i perhershem (kercim)",
    "Phone number": "",
    "Plan": "Plani",
    "Plan checkout was cancelled.": "Pagesa e planit u anullua.",
    "Plan upgrade was cancelled.": "Përmirësimi i planit u anullua.",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "",
    "Please enter {fieldName}": "",
    "Please fill in required fields": "Ju lutem plotesoni fushat e kerkuara",
    "Podcasts": "",
    "Postal code": "",
    "Re-enable emails": "Ri-aktivizo emailet",
    "Recipient's email": "",
    "Recipient's name": "",
    "Recommendations": "",
    "Redeem your gift": "",
    "Redeeming...": "",
    "Renews at {price}.": "Rinovohet per {price} ",
    "Resume subscription": "",
    "Retry": "Provo perseri",
    "Save": "Ruaj",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Security verification": "",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "Duke derguar linkun e identifikimit...",
    "Sending...": "Duke derguar...",
    "Share": "Shpërndaj",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Share it yourself": "",
    "Show all": "",
    "Sign in": "Hyr",
    "Sign out": "Dil",
    "Sign up": "Rregjistrohu",
    "Signup error: Invalid link": "Gabim ne rregjistrim: Link i pavlefshem",
    "Signups from this email domain are currently restricted.": "",
    "Something went wrong, please try again later.": "",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "",
    "Sorry, that didn’t work.": "Na vjen keq, kjo nuk funksionoi.",
    "Spam complaints": "Ankesat për mesazhe të padëshiruara",
    "Start {amount}-day free trial": "",
    "Starting {startDate}": "Duke filluar {startDate}",
    "Starting today": "Duke filluar nga sot",
    "State": "",
    "Submit feedback": "Dergo komente",
    "Subscribe": "Abonohu",
    "Subscribed": "Abonuar",
    "Subscription plan updated successfully": "",
    "Success": "Sukses",
    "Success! Check your email for magic link to sign-in.": "Sukses! Kontrollo emailin tend per linkun magjik te indentifikimit.",
    "Success! Your account is fully activated, you now have access to all content.": "Sukses! Llogaria jote eshte plotesisht e aktivizuar, tashme ju keni akses ne te githe kontentin",
    "Success! Your email is updated.": "Sukses! Emaili yt eshte rifreskuar",
    "Successfully unsubscribed": "Çabonuar me sukses",
    "Taylor Reid": "",
    "taylor@example.com": "",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "",
    "Thank you for your support": "",
    "Thank you for your support!": "",
    "Thanks for the feedback!": "Faleminderit per komentin!",
    "That didn't go to plan": "Kjo nuk shkoi sipas planit",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "",
    "There was a problem submitting your feedback. Please try again a little later.": "Pati një problem me dërgimin e komenteve tuaja. Ju lutemi provoni sërish pak më vonë.",
    "There was an error cancelling your subscription, please try again.": "",
    "There was an error continuing your subscription, please try again.": "",
    "There was an error processing your payment. Please try again.": "",
    "There was an error sending the email, please try again": "",
    "This gift can only be redeemed once and expires on {expiryDate}.": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This gift link is invalid.": "",
    "This site is invite-only, contact the owner for access.": "Kjo faqe eshte vetem me ftesa, kontaktoni zoteruesin per akses.",
    "This site is not accepting donations at the moment.": "",
    "This site is not accepting payments at the moment.": "",
    "This site only accepts paid members.": "",
    "This unsubscribe link belongs to a different email address than the one you are signed in with.": "",
    "Threads": "",
    "Tier": "",
    "To": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "Për të përfunduar regjistrimin, klikoni lidhjen e konfirmimit në kutinë tuaj hyrëse. Nëse nuk arrin brenda 3 minutash, kontrolloni dosjen tuaj të postës elektronike!",
    "To continue to stay up to date, subscribe to {publication} below.": "",
    "Too many attempts try again in {number} days.": "",
    "Too many attempts try again in {number} hours.": "",
    "Too many attempts try again in {number} minutes.": "",
    "Too many different sign-in attempts, try again in {number} days": "",
    "Too many different sign-in attempts, try again in {number} hours": "",
    "Too many different sign-in attempts, try again in {number} minutes": "",
    "Too many sign-up attempts, try again later": "",
    "Try free for {amount} days, then {originalPrice}.": "Provo falas per {amount} dite, pastaj {originalPrice}.",
    "Unable to initiate checkout session": "",
    "Unable to verify your request, please try again": "",
    "Unlock access to all newsletters by becoming a paid subscriber.": "Zhbllokoni aksesin per te gjitha buletinet duke u bere nje abonues me pagese.",
    "Unsubscribe from all emails": "Çregjistrohu nga të gjitha emailet",
    "Unsubscribed": "I çabonuar",
    "Unsubscribed from all emails.": "",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "Çregjistrimi nga emailet nuk do ta anulojë abonimin tuaj me pagesë në {title}",
    "Update": "Rifresko",
    "Update your preferences": "Përditësoni preferencat tuaja",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "",
    "Verify your email address is correct": "Verifikoni që adresa juaj e emailit është e saktë",
    "Verifying...": "",
    "View plans": "Shiko planet",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "We'll email it to the recipient on {deliveryDate}. A copy is in your inbox too.": "",
    "We'll email it to the recipient. A copy will be in your inbox too.": "",
    "Welcome back, {name}!": "Mire se erdhe, {name}!",
    "Welcome back!": "Mire se erdhe!",
    "Welcome to {siteTitle}": "",
    "What's included": "",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "Kur një kuti hyrëse dështon të pranojë një email, zakonisht quhet kthim. Në shumë raste, kjo mund të jetë e përkohshme. Megjithatë, në disa raste, një email i kthyer mund të kthehet si një dështim i përhershëm kur një adresë emaili është e pavlefshme ose nuk ekziston.",
    "Why has my email been disabled?": "Pse është çaktivizuar emaili im?",
    "X (Twitter)": "",
    "year": "vit",
    "Yearly": "Vjetore",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "Ju keni aktualisht nje antaresim falas, beni abonimin me pagese per akses te plote. ",
    "You have been successfully resubscribed": "Ju jeni ri-abonuar me sukses",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "Aktualisht nuk po merrni emaile",
    "You're not receiving emails": "Ju nuk po merrni emaile",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "Ju nuk po merrni email sepse ose keni shënuar një mesazh të fundit si të padëshiruar, ose sepse mesazhet nuk mund të dërgoheshin në adresën tuaj të emailit të dhënë.",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_other": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "You've successfully signed in.": "Ju jeni identifikuar me sukses.",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "",
    "Your account": "Llogaria juar",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "",
    "Your gift is on its way": "",
    "Your gift is ready": "Dhurata juaj është gati",
    "Your gift is scheduled": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "",
    "Your input helps shape what gets published.": "Të dhënat tuaja ndihmojnë në formimin e asaj që publikohet.",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "Abonimi juaj do te skadoje ne {expiryDate}",
    "Your subscription will renew on {renewalDate}": "Abonimi juaj to te rinovohet ne {renewalDate}",
    "Your subscription will start on {subscriptionStart}": "Abonimi juaj do te filloje ne {subscriptionStart}"
}
